import { render, staticRenderFns } from "./DivFilter.vue?vue&type=template&id=2723da1e&scoped=true"
import script from "./DivFilter.vue?vue&type=script&lang=js"
export * from "./DivFilter.vue?vue&type=script&lang=js"
import style0 from "./DivFilter.vue?vue&type=style&index=0&id=2723da1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2723da1e",
  null
  
)

export default component.exports